import React, { useState, useEffect } from "react";
import "./VivaCharity.css";
import "./MobileEnhancements.css";
import "./LoadingScreen.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import VivaCharity from "./components/VivaCharity";
import SolicitarDoacoesPremium from "./components/SolicitarDoacoesPremium";
import SuccessPage from "./components/SuccessPage";
import AcoesSociais from "./components/AcoesSociais";
import RegioesSociais from "./components/RegioesSociais";
import MapaAcoes from "./components/MapaAcoes";
import AdminDashboardPremium from "./components/AdminDashboardPremium";
import LoadingScreen from "./components/LoadingScreen";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Verificar se já foi mostrado nesta sessão
    const hasLoadedBefore = sessionStorage.getItem('viva_loaded');
    
    if (hasLoadedBefore) {
      setIsLoading(false);
      setShowContent(true);
    } else {
      // BLOQUEAR SCROLL no body enquanto loading está ativo
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = '0';
    }
  }, []);

  const handleLoadingComplete = () => {
    // LIBERAR SCROLL quando loading terminar
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    
    sessionStorage.setItem('viva_loaded', 'true');
    setIsLoading(false);
    setTimeout(() => setShowContent(true), 100);
  };

  return (
    <div className="App">
      {/* Loading Screen - só mostra na primeira visita da sessão */}
      {isLoading && <LoadingScreen onComplete={handleLoadingComplete} />}
      
      {/* Main Content */}
      <div className={`main-content ${showContent ? 'visible' : ''}`}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<VivaCharity />} />
            <Route path="/solicitar-doacoes" element={<SolicitarDoacoesPremium />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/acoes" element={<AcoesSociais />} />
            <Route path="/acoes-sociais" element={<AcoesSociais />} />
            <Route path="/regioes" element={<RegioesSociais />} />
            <Route path="/mapa-acoes" element={<MapaAcoes />} />
            <Route path="/admin" element={<AdminDashboardPremium />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
